import { Route } from '@angular/router';

export const PlanningRoute: Route = {
  path: 'planning',
  loadComponent() {
    return import('@daas-consulting/production/shared/frontend/pages').then(
      (c) => c.LayoutBase2PageComponent
    );
  },
  loadChildren() {
    return import(
      '@daas-consulting/production/shared/frontend/planning_shell'
    ).then((c) => c.planningShellRoutes);
  },
};
